import axios from 'axios'

const HTTPS = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

HTTPS.interceptors.response.use(response => {
    return response
 }, async (error) => {
    if (error.response.status === 401) {
        let originalRequest = error.config
        let res = await refreshToken()
        if (res === 0) {
            originalRequest.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
            HTTPS.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('token')}`

            return HTTPS(originalRequest)
        }
        else
            location.reload()
    }
    return Promise.reject(error)
 })

  async function refreshToken() {
    try {
        let response = await axios.post(process.env.VUE_APP_API_URL + '/users/refreshtoken', '{ "token": "' + localStorage.getItem('token') + '", "refreshtoken": "' + localStorage.getItem('refreshToken') + '" }', { headers: { "Content-Type": "application/json" } })

        localStorage.setItem('token', response.data.token)

        return 0
    }
    catch (e) {
        localStorage.removeItem('userId')
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')

        return 1
    }
}


export default {
    HTTPS: HTTPS
}